import React from 'react';

// The body of a card whose header is already painted — used by cards that know
// their own identity immediately and are only waiting on a list.
export const CardBodySkeleton = ({ rows = 1 }) => (
  <div className="flex-1 border-t border-gray-200 dark:border-gray-700/30 pt-4 space-y-3 animate-pulse">
    <div className="h-3 w-full rounded bg-gray-200/50 dark:bg-white/[0.04]" />
    <div className="h-3 w-4/5 rounded bg-gray-200/50 dark:bg-white/[0.04]" />
    {Array.from({ length: rows }).map((_, i) => (
      <div key={i} className="h-12 rounded-xl bg-gray-100/80 dark:bg-white/[0.03]" />
    ))}
  </div>
);

// Placeholder that occupies the same footprint as a real integration card, so
// the grid has its final shape on first paint and nothing jumps when the data
// lands. `rows` matches the number of list items the card will show.
const CardSkeleton = ({ rows = 1 }) => (
  <div className="bg-white/60 dark:bg-gray-900/40 backdrop-blur-xl rounded-xl border border-gray-200/60 dark:border-gray-700/40 shadow-lg shadow-gray-200/40 dark:shadow-black/20 p-6 flex flex-col animate-pulse">
    <div className="flex items-center gap-4 mb-4">
      <div className="w-12 h-12 rounded-xl bg-gray-200/70 dark:bg-white/[0.06]" />
      <div className="space-y-2">
        <div className="h-4 w-28 rounded bg-gray-200/70 dark:bg-white/[0.06]" />
        <div className="h-3 w-44 rounded bg-gray-200/50 dark:bg-white/[0.04]" />
      </div>
    </div>
    <div className="border-t border-gray-200 dark:border-gray-700/30 pt-4 space-y-3">
      <div className="h-3 w-full rounded bg-gray-200/50 dark:bg-white/[0.04]" />
      <div className="h-3 w-4/5 rounded bg-gray-200/50 dark:bg-white/[0.04]" />
      {Array.from({ length: rows }).map((_, i) => (
        <div key={i} className="h-12 rounded-xl bg-gray-100/80 dark:bg-white/[0.03]" />
      ))}
    </div>
  </div>
);

export default CardSkeleton;
